var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47217(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 601,
    viewBox: "0 0 601 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8945_318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 300.5,
    r: 300.5,
    fill: "#8279D4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8945_318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 601,
    height: 601
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 300.5,
    r: 300.5,
    fill: "#C3EEFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8945_318)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8945_318)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.504,
    cy: 152.611,
    rx: 353.462,
    ry: 292.441,
    fill: "#F5D7FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8945_318)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.854,
    cy: -23.5215,
    rx: 353.462,
    ry: 292.441,
    fill: "#FFFCED"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8945_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.038 15.4621C93.4442 84.0326 49.0751 203.695 49.0751 424.196C-73.0756 424.196 -157.309 145.781 -157.309 15.4621C-157.309 -114.857 -58.2859 -220.501 63.8648 -220.501C186.015 -220.501 285.038 -114.857 285.038 15.4621Z",
    fill: "#CFB1EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8945_318",
    x: -24.4832,
    y: -18.3624,
    width: 625.483,
    height: 619.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24.4832,
    dy: -18.3624
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.6644
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8945_318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8945_318",
    x: -285.911,
    y: -390.783,
    width: 1208.83,
    height: 1086.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125.477,
    result: "effect1_foregroundBlur_8945_318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8945_318",
    x: -3.56117,
    y: -566.915,
    width: 1208.83,
    height: 1086.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125.477,
    result: "effect1_foregroundBlur_8945_318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8945_318",
    x: -273.604,
    y: -336.796,
    width: 674.937,
    height: 877.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.1476,
    result: "effect1_foregroundBlur_8945_318"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47217);
export default __webpack_public_path__ + "static/media/Group 47217.476bb3d49abb7f1d8b8f9665ef1f1299.svg";
export { ForwardRef as ReactComponent };